import requestService from '../requestService';
import store from '@/store';
//import AuthService from '../Auth/AuthService'
//import router from '../../router'

export default {
    async createBusiness(form) {
        try {
            const response = await requestService.post('/business', form, {
                headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
            })
            return response?.data
        }
        catch {
            //AuthService.refreshToken().then(this.createBusiness(form))
        }
    },
    async checkName(form) {
        try {
            const response = await requestService.post('/business/check_name', form, {
                headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
            })
            if(response?.data) {
                return response?.data
            }
            
        }
        catch {
            //AuthService.refreshToken().then(this.createBusiness(form))
        }
    },
    async checkRefferal(form) {
        try {
            const response = await requestService.post('/business/check_referral', form, {
                headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
            })
            return response?.data
        }
        catch {
            // AuthService.refreshToken().then((res) => {
            //     this.checkRefferal(form)
            // })
        }
    },
    async getListBusiness() {
        try {
            const response = await requestService.get('/business', {
                headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
            })
            if(response?.data) {
                return response?.data
            }
        }
        catch (e) {
            // if (e.response.status == 401) {
            //     AuthService.refreshToken().then(() => {
            //         return this.getListBusiness()
            //     })
            // }
            // else {
            //     store.commit("clearUserLogged");
            //     router.push('/login')
            // }
        }
    },
    async getOneBusiness(id) {
        try {
            const response = await requestService.get('/business/' + id, {
                headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
            })
            return response?.data
        }
        catch {
            // AuthService.refreshToken().then(() => {
            //     this.getOneBusiness(id)
            // })
        }
    },
    async updateBusiness(id, form) {
        try {
            const response = await requestService.post('/business/' + id, form, {
                headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
            })
            return response?.data
        }
        catch {
            // AuthService.refreshToken().then(() => {
            //     this.updateBusiness(id, form)
            // })
        }
    },
}